import { useEffect } from 'react';
import { useConfig } from '../../config';
import { MetaContainer } from '../../state/meta';

export const TorkFacebookTracking = ({ initTracking, brand }: { initTracking?: boolean; brand?: string }): null => {
	const { store } = useConfig();
	const { marketing } = MetaContainer.useContainer().trackingConsents;

	useEffect(() => {
		if (store !== 'kgno' || !marketing) return;

		if (typeof window !== 'undefined' && typeof window.fbq !== 'undefined') {
			if (initTracking || brand?.toLowerCase() === 'tork') {
				window.fbq('track', 'ViewContent');
			}
		}
	}, [store, marketing, initTracking, brand]);

	return null;
};
